export enum PortfolioHistoryTimeframeEnum {
	ONE_MINUTE = '1Min',
	FIVE_MINUTES = '5Min',
	FIFTEEN_MINUTES = '15Min',
	ONE_HOUR = '1H',
	ONE_DAY = '1D',
}
